import jwtDecode from 'jwt-decode'
import { WEPIN_PROMOTION_URL, WEPIN_TOKEN, WEPIN_TOKENLESS_URL } from '@/const'
import { TokenExpiredError } from '@/erros/TokenExpiredError'
import { RequestMethod } from '@/networks/api/APITypes'
import { useGlobalState } from '@/stores'
/**
 * for facade jwt token
 */

export const getLocalStorage = () => {
  const storage = useGlobalState()
  try {
    try {
      return JSON.parse(storage.value)
    } catch (e) {
      return storage.value
    }
  } catch (error) {
    return false
  }
}
export const setLocalStorage = ({
  key,
  value,
}: {
  key: string
  value: any
}) => {
  let data = value
  if (key === WEPIN_TOKEN && value.access) {
    const accessToken = value.access
    const refreshToken = value?.refresh
    data = {
      refreshToken: refreshToken,
      accessToken: accessToken,
    }
  }
  if (typeof data !== 'string') {
    data = JSON.stringify(data)
  }

  try {
    const storage = useGlobalState()
    storage.value = data
    return true
  } catch (error) {
    return false
  }
}

export const isExpiredAccessToken = () => {
  const accessToken = getLocalStorage()?.accessToken
  if (!accessToken) return true
  const expired = (jwtDecode(accessToken) as any)?.exp

  if (expired <= Math.floor(Date.now() / 1000)) return true
  return false
}

export const isExpiredRefreshToken = () => {
  const refreshToken = getLocalStorage()?.refreshToken
  if (!refreshToken) return true
  const expired = (jwtDecode(refreshToken) as any)?.exp
  if (expired <= Math.floor(Date.now() / 1000)) return true
  return false
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isTokenExpired = (requestURL: string, method: RequestMethod) => {
  // if (
  //   requestURL !== '/' &&
  //   (WEPIN_TOKENLESS_URL.find((url) => url.includes(requestURL)) ||
  //     (WEPIN_SEARCH_URL.find((url) => requestURL.startsWith(url)) &&
  //       method === 'GET'))
  // ) {
  if (
    requestURL !== '/' &&
    (WEPIN_TOKENLESS_URL.find((url) => requestURL.includes(url)) ||
      requestURL.startsWith(WEPIN_PROMOTION_URL))
  ) {
    return
  }
  if (isExpiredRefreshToken()) {
    throw new TokenExpiredError('refresh_expired')
  }

  if (isExpiredAccessToken()) {
    throw new TokenExpiredError('access_expired')
  }
}
